/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import router from '@/router'

const firestore = firebase.firestore()

export default {
  loginAttempt ({dispatch}, payload)
  {

    // New payload for login action
    const newPayload = {
      userDetails:    payload.userDetails,
      notify:         payload.notify,
      closeAnimation: payload.closeAnimation
    }

    // If remember_me is enabled change firebase Persistence
    if (!payload.checkbox_remember_me)
    {

      // Change firebase Persistence
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)

        // If success try to login
        .then(function () {
          dispatch('login', newPayload)
        })

        // If error notify
        .catch(function (err) {

          // Close animation if passed as payload
          if (payload.closeAnimation) payload.closeAnimation()

          payload.notify({
            time:     2500,
            title:    'Error',
            text:     err.message,
            iconPack: 'feather',
            icon:     'icon-alert-circle',
            color:    'danger'
          })
        })
    } else
    {
      // Try to login
      dispatch('login', newPayload)
    }
  },
  postLoginActions ({commit}, payload)
  {
    firestore
      .collection('users')
      .doc(firebase.auth().currentUser.uid)
      .get()
      .then(function (doc) {
        const userData = doc.data() || {}
        userData.id    = doc.id
        console.log('current data:', doc.data())

        if (!userData.cityID || userData.cityID.length === 0)
        {
          firebase.auth().signOut()
          return
        }

        // Include properties from localStorage
        Object.keys(payload).forEach((key) => {
          if (userData[key] === undefined) userData[key] = payload[key]
        })

        commit('UPDATE_USER_INFO', userData, {root: true})
      })

  },
  login ({state, dispatch}, payload)
  {

    // If user is already logged in notify and exit
    if (state.isUserLoggedIn())
    {
      // Close animation if passed as payload
      if (payload.closeAnimation) payload.closeAnimation()

      payload.notify({
        title:    'Login Attempt',
        text:     'You are already logged in!',
        iconPack: 'feather',
        icon:     'icon-alert-circle',
        color:    'warning'
      })

      return false
    }

    // Try to sigin
    firebase.auth()
      .signInWithEmailAndPassword(payload.userDetails.email, payload.userDetails.password)
      .then(() => {

        // Close animation if passed as payload
        if (payload.closeAnimation) payload.closeAnimation()

        router.push(router.currentRoute.query.to || '/')

        dispatch('postLoginActions', {
          displayName: payload.userDetails.displayName,
          email:       payload.userDetails.email
        })
      }, (err) => {

        // Close animation if passed as payload
        if (payload.closeAnimation) payload.closeAnimation()

        payload.notify({
          time:     2500,
          title:    'Error',
          text:     err.message,
          iconPack: 'feather',
          icon:     'icon-alert-circle',
          color:    'danger'
        })
      })
  },

  // Google Login
  loginWithGoogle ({state, dispatch}, payload)
  {
    if (state.isUserLoggedIn())
    {
      payload.notify({
        title:    'Login Attempt',
        text:     'You are already logged in!',
        iconPack: 'feather',
        icon:     'icon-alert-circle',
        color:    'warning'
      })
      return false
    }
    const provider = new firebase.auth.GoogleAuthProvider()

    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        router.push(router.currentRoute.query.to || '/')

        const providerData = result.user.providerData[0]

        dispatch('postLoginActions', {
          displayName: providerData.displayName,
          email:       providerData.email,
          phoneNumber: providerData.phoneNumber,
          photoURL:    providerData.photoURL
        })
      }).catch((err) => {
      payload.notify({
        time:     2500,
        title:    'Error',
        text:     err.message,
        iconPack: 'feather',
        icon:     'icon-alert-circle',
        color:    'danger'
      })
    })
  },

  // Facebook Login
  loginWithFacebook ({commit, state}, payload)
  {
    if (state.isUserLoggedIn())
    {
      payload.notify({
        title:    'Login Attempt',
        text:     'You are already logged in!',
        iconPack: 'feather',
        icon:     'icon-alert-circle',
        color:    'warning'
      })
      return false
    }
    const provider = new firebase.auth.FacebookAuthProvider()

    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        router.push(router.currentRoute.query.to || '/')
        commit('UPDATE_USER_INFO', result.user.providerData[0], {root: true})
      }).catch((err) => {
      payload.notify({
        time:     2500,
        title:    'Error',
        text:     err.message,
        iconPack: 'feather',
        icon:     'icon-alert-circle',
        color:    'danger'
      })
    })
  },

  // Twitter Login
  loginWithTwitter ({commit, state}, payload)
  {
    if (state.isUserLoggedIn())
    {
      payload.notify({
        title:    'Login Attempt',
        text:     'You are already logged in!',
        iconPack: 'feather',
        icon:     'icon-alert-circle',
        color:    'warning'
      })
      return false
    }
    const provider = new firebase.auth.TwitterAuthProvider()

    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        router.push(router.currentRoute.query.to || '/')

        commit('UPDATE_USER_INFO', result.user.providerData[0], {root: true})
      }).catch((err) => {
      payload.notify({
        time:     2500,
        title:    'Error',
        text:     err.message,
        iconPack: 'feather',
        icon:     'icon-alert-circle',
        color:    'danger'
      })
    })
  },

  // Github Login
  loginWithGithub ({commit, state}, payload)
  {
    if (state.isUserLoggedIn())
    {
      payload.notify({
        title:    'Login Attempt',
        text:     'You are already logged in!',
        iconPack: 'feather',
        icon:     'icon-alert-circle',
        color:    'warning'
      })
      return false
    }
    const provider = new firebase.auth.GithubAuthProvider()

    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        router.push(router.currentRoute.query.to || '/')
        commit('UPDATE_USER_INFO', result.user.providerData[0], {root: true})
      }).catch((err) => {
      payload.notify({
        time:     2500,
        title:    'Error',
        text:     err.message,
        iconPack: 'feather',
        icon:     'icon-alert-circle',
        color:    'danger'
      })
    })
  },
  registerUser ({dispatch}, payload)
  {

    // create user using firebase
    firebase.auth().createUserWithEmailAndPassword(payload.userDetails.email, payload.userDetails.password)
      .then(response => {
        payload.notify({
          title:    'Account Created',
          text:     'You are successfully registered!',
          iconPack: 'feather',
          icon:     'icon-check',
          color:    'success'
        })

        firebase
          .firestore()
          .collection('users')
          .doc(response.user.uid)
          .set({
            displayName: payload.userDetails.displayName,
            cityID:      null,
          }, {merge: true})

        const newPayload = {
          userDetails: payload.userDetails,
          notify:      payload.notify
        }
        dispatch('login', newPayload)

      }, (error) => {
        payload.notify({
          title:    'Error',
          text:     error.message,
          iconPack: 'feather',
          icon:     'icon-alert-circle',
          color:    'danger'
        })
      })
  }
}
